<div class="order-executers-common-view">
  <div class="row">
    <ng-container *ngFor="let item of items">
      <ng-container *ngIf="item.value">
        <div class="col">
          <div class="item flex align-items-center" [ngClass]="{'item--clickable': !!item.config.click}"
            (click)="click(item)">
            <div class="item__avatar">
              <app-avatar-view [avatarUrl]="item.value.avatarUrl" [size]="'50px'"></app-avatar-view>
            </div>
            <div class="item__executer ms-3">
              <div class="item__role">
                <strong class="item__header">{{ item.config.role }}</strong>
              </div>
              <strong class="item__name">{{ item.value.firstName }} {{ item.value.lastName }}</strong>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>